import { RootState } from '../store';

export const getLoggedInUser = (store: RootState) => store.auth.user;
export const getAuthLoadingStatus = (store: RootState) => store.auth.loading;
